export enum ProjectStatus {
  InDevelopment = 0,
  Live = 1,
  Closed = 2,
  Deleted = 3,
}
